/**
 * @fileoverview Component featuring a set of Cards with Content Skeletons of differing widths within each card.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import {Card} from '/ui/components/card/card';
import {ContentSkeleton} from '/ui/components/contentskeleton/contentskeleton';
import {useIsSmallViewport} from '/ui/lib/responsivity';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/contentskeletoncards.module.scss';

const ContentSkeletonCards = () => {
  const isSmallViewport = useIsSmallViewport();
  const contentSkeletonRowWidths = [88, 138, 216, 105, 143, 240];

  return (
    <div className={styles.contentSkeletonCards}>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div key={index} className={!isSmallViewport ? styles.contentSkeletonCardDesktop : ''}>
            <Card isFullWidth={isSmallViewport} taskFlowStyle={true}>
              <Card.Body>
                {contentSkeletonRowWidths.map(contentSkeletonRowWidth =>
                  <div key={contentSkeletonRowWidth} className={styles.contentSkeletonRow}>
                    <ContentSkeleton width={contentSkeletonRowWidth} />
                  </div>)}
              </Card.Body>
            </Card>
          </div>
        ))}
    </div>
  );
};

export default ContentSkeletonCards;
